import { createContext } from 'react';

/**
 * @ignore - Do not document.
 */
const DropdownInnerContext = /*#__PURE__*/createContext({});
export default DropdownInnerContext;